import { Text } from '@chakra-ui/react'
import { Discount } from 'BrokerTsLib/src/dtos'
import { DiscountBase } from 'BrokerTsLib/src/dtos/StepBase'
import { useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Loading } from '../../components/Loading'
import { useGetInsuranceParamsDiscounts } from '../../hooks/useInsuranceParams'
import { insuranceParamsContext } from '../../layouts/Wizard'

import { BusinessCompanyDiscount } from './BusinessCompanyDiscount'
import { BusinessDiscountsWrapper } from './BusinessDiscountsWrapper'

export const BusinessDiscounts = () => {
  const { insuranceParamsId: paramsId } = useContext(insuranceParamsContext)!
  const { setValue, watch } = useFormContext<DiscountBase>()

  const { data, refetch, isLoading, isFetching } = useGetInsuranceParamsDiscounts(paramsId ?? '', {
    enabled: false,
    onSuccess: ({ data }) => {
      // do forumulare se ulozi plocha struktura pouze slev

      const iDisc = data ?? []

      // select many vsech slev (pro post nepotrebuji data o pojistovne)
      const flat = iDisc.reduce((current: Discount[], insurerDiscounts) => [...current, ...insurerDiscounts.discounts ?? []], []) ?? [];

      setValue('discounts', flat)
    },
  })

  useEffect(() => {
    if (!!paramsId) refetch()
  }, [paramsId]);

  const loading = isLoading || isFetching

  const insurersDiscounts = data?.data ?? []
  insurersDiscounts.forEach(x => x.discounts = x.discounts?.filter(d => d.editK1) ?? [])

  const anyDiscount = insurersDiscounts.findIndex(x => x.discounts.length > 0) >= 0

  return (
    <>
      {loading
        && <Loading large={true} />}

      {!loading && ((insurersDiscounts ?? []).length === 0 || !anyDiscount)
        && <Text textAlign='center'>Žádné slevy nejsou k dispozici</Text>}

      {!loading && (insurersDiscounts ?? []).length > 0 && anyDiscount &&
        <BusinessDiscountsWrapper>
          {insurersDiscounts.map((insurerDiscounts) =>
            insurerDiscounts.discounts.length > 0 && <BusinessCompanyDiscount key={insurerDiscounts.insurerId} {...insurerDiscounts} />
          )}
        </BusinessDiscountsWrapper>
      }
    </>
  )
}
